import React, { Component } from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route
  } from "react-router-dom";
  import Source from './Source';
  import Home from './Home';

export default class App extends Component {
  state = {
    shouldBlockNavigation:true
  }

  // componentDidUpdate = () => {
  //   if (this.state.shouldBlockNavigation) {
  //     window.history.back()
  //   } 
  // }
  render() {
    return (
      <>
      {/* <Prompt
          when={this.state.shouldBlockNavigation}
          message='You have unsaved changes, are you sure you want to leave?'
        /> */}
      <Router>
        <Switch>
          <Route path="/source" component={(props) =>  <Source {...props} />} />
          <Route path="/" component={(props) =>  <Home {...props} />} />
        </Switch>
      </Router>
      </>
    )
  }
}
